import { defaultFilter } from "cmdk";

import { isSearchable } from "@/features/search/lib/query";

/* Server results carry this prefix in their cmdk value; the server already matched them. */
const RESULT_PREFIX = "search-result:";
/* The palette's own project list, which the server's results replace during a search. */
const PROJECT_PREFIX = "project:";

export type ResultKind = "project" | "task" | "client" | "person";

/** The cmdk value of a server result: unique, and recognised by paletteFilter. */
export function resultValue(kind: ResultKind, id: string): string {
  return `${RESULT_PREFIX}${kind}:${id}`;
}

/** The cmdk value of a project in the palette's own list. */
export function projectItemValue(key: string, name: string): string {
  return `${PROJECT_PREFIX}${key} ${name}`;
}

/**
 * The command palette's filter. Server results always match: the server already searched
 * names, titles, clients and Arabic spellings. While a search is on, the palette's own project
 * list steps aside for them. Everything else uses cmdk's fuzzy match. Hiding through the filter
 * (rather than unmounting items) keeps cmdk's selection right, so Enter opens the first result.
 */
export function paletteFilter(value: string, search: string, keywords?: string[]): number {
  if (value.startsWith(RESULT_PREFIX)) return 1;
  if (value.startsWith(PROJECT_PREFIX) && isSearchable(search)) return 0;
  return defaultFilter(value, search, keywords);
}
